import PadlockIcon from "@/images/PadlockIcon";
import BaseBadge from "@/tpo/Badge";
import Group from "@/tpo/Group";
import ButtonV2 from "@/v2/Buttons";

import StatusBadge from "../StatusBadge";

export const ComingSoonBadge = () => {
  return (
    <Group gap={8} alignItems="center">
      <PadlockIcon width={12} height={12} />
      <BaseBadge
        backgroundColor="midGrey"
        color="white"
        size="xs"
        borderRadius={5}
        fontSize={10}
        letterSpacing="1.5px"
      >
        Coming soon
      </BaseBadge>
    </Group>
  );
};

export const UnlockBadge = () => {
  return (
    <Group gap={8} alignItems="center" mm="auto">
      <PadlockIcon width={12} height={12} />
      <ButtonV2 size="xs" color="dark">
        Unlock
      </ButtonV2>
    </Group>
  );
};


export const UnreleasedBadge = () => {
  return (
    <Group gap={8} alignItems="center" mm="auto">
      <PadlockIcon width={12} height={12} />
      <ButtonV2 size="xs" color="dark">
        Unreleased
      </ButtonV2>
    </Group>
  );
};

export const AvailableBadge = () => {
  return (
    <StatusBadge variant="success" mb="auto">
      Available
    </StatusBadge>
  );
};

/** Badge for an ordered report on CMP order detail (patient report list semantics). */
export function OrderedReportStatusBadge({ hasUserReport }) {
  if (hasUserReport) {
    return <AvailableBadge />;
  }

  return <Badge>Awaiting Results</Badge>;
}

/** Badge for an ordered report on customer/ward order detail (report isAvailable semantics). */
export function ConsumerReportOrderStatusBadge({ isAvailable }) {
  if (isAvailable) {
    return <AvailableBadge />;
  }

  return <UnreleasedBadge />;
}

export function Badge({ children, ...props }) {
  return (
    <BaseBadge
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      bg="dark"
      color="white"
      py={12}
      px={20}
      borderRadius={100}
      fontSize={10}
      lineHeight="100%"
      maxHeight={28}
      height={28}
      {...props}
    >
      {children}
    </BaseBadge>
  );
}